import React, {Component} from 'react'
import {Button, Collapse, Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {toast} from "react-toastify";
import {Mutation} from 'react-apollo'

import UserRoleHistoryList from "./UserRoleHistoryList";
import {UserRoleHistoryInput} from "./UserRoleHistoryInput";
import userRoleTimesheetCheck from "../../../queries/server/mutations/user_role_timesheet_check";
import createUserRoleHistory from "../../../queries/server/mutations/create_user_role_history";
import localMutation from '../../../queries/client_side/mutations/edit_user'

export default class UserRoleHistory extends Component {

    constructor(props){
        super(props)

        this.newRecord = null
    }

    state = {
        showInput: false,
        timesheetAlertOpen: false,
    }

    toggle = () => {
        this.setState({showInput: !this.state.showInput})
    }

    toggleTimesheetAlert = () => {
        this.setState({timesheetAlertOpen: !this.state.timesheetAlertOpen})
    }

    render() {

        const {state, props, newRecord} = this

        return (
            <Mutation mutation={localMutation}>
                {(updateLocalUserDetailsFunc) => (
                    <Mutation mutation={createUserRoleHistory}>
                        {(createUserRoleHistoryFunc, {loading}) => (
                            <Mutation mutation={userRoleTimesheetCheck}>
                                {(userRoleTimesheetCheckFunc, {loading}) => (
                                    <div>
                                        <Button
                                            size="sm"
                                            color={state.showInput ? 'warning' : 'success'}
                                            onClick={this.toggle}
                                        >
                                            <FontAwesomeIcon color="#fff"
                                                             icon={state.showInput ? 'minus' : 'plus'}/>{' '}
                                            {state.showInput ? 'Cancel' : 'Change User Role'}
                                        </Button>

                                        <Collapse isOpen={state.showInput}>
                                            <div className="d-flex flex-column pt-3 mt-3 card card-body bg-light">

                                                <UserRoleHistoryInput
                                                    onCancel={this.toggle}
                                                    loading={loading}
                                                    onSave={(data) => {

                                                        this.newRecord = data

                                                        userRoleTimesheetCheckFunc({
                                                            variables: {
                                                                user_id: props.user_id,
                                                                user_role_id: data.user_role_id,
                                                                active_from: data.active_from
                                                            }
                                                        })
                                                            .then(result => {
                                                                console.log('result', result)
                                                                const {data: {checkTimesheetsAfterUserRoleChange}} = result

                                                                if (checkTimesheetsAfterUserRoleChange > 0) {
                                                                    this.toggleTimesheetAlert()
                                                                }
                                                                else{
                                                                    createUserRoleHistoryFunc({
                                                                        variables: {
                                                                            data: {
                                                                                user_id: props.user_id,
                                                                                user_role_id: this.newRecord.user_role_id,
                                                                                active_from: this.newRecord.active_from
                                                                            },
                                                                            update_timesheets: false
                                                                        }
                                                                    })
                                                                        .then(({data}) => {
                                                                            updateLocalUserDetailsFunc({variables: {data: data.createUserRoleHistory}})
                                                                            toast.success('User Details Updated', {autoClose: 2000})
                                                                        })
                                                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                                                }
                                                            })
                                                    }}
                                                />


                                            </div>
                                        </Collapse>

                                        <UserRoleHistoryList data={props.data}/>

                                        <Modal isOpen={this.state.timesheetAlertOpen}>
                                            <ModalHeader>Timesheets Update</ModalHeader>
                                            <ModalBody>
                                                There are a number of timesheets, submitted by this user, which are
                                                after the
                                                specified "Active From Date".
                                                Would you like to update the timesheets with the new user role hourly
                                                rate?
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button
                                                    size="sm"
                                                    color="secondary"
                                                    disabled={loading}
                                                    onClick={() => {
                                                        createUserRoleHistoryFunc({
                                                            variables: {
                                                                data: {
                                                                    user_id: props.user_id,
                                                                    user_role_id: this.newRecord.user_role_id,
                                                                    active_from: this.newRecord.active_from
                                                                },
                                                                update_timesheets: false
                                                            }
                                                        })
                                                            .then(({data}) => {
                                                                updateLocalUserDetailsFunc({variables: {data: data.createUserRoleHistory}})
                                                                toast.success('User Details Updated', {autoClose: 2000})
                                                                this.toggleTimesheetAlert()
                                                            })
                                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        color="#fff"
                                                        icon={loading ? 'spinner' : 'times'}
                                                        spin={loading}
                                                    />{' '}
                                                    {(loading) ? 'Saving...' : "Don't Update"}
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    color="success"
                                                    type="submit"
                                                    disabled={loading}
                                                    onClick={() => {
                                                        createUserRoleHistoryFunc({
                                                            variables: {
                                                                data: {
                                                                    user_id: props.user_id,
                                                                    user_role_id: this.newRecord.user_role_id,
                                                                    active_from: this.newRecord.active_from
                                                                },
                                                                update_timesheets: true
                                                            }
                                                        })
                                                            .then(({data}) => {
                                                                updateLocalUserDetailsFunc({variables: {data: data.createUserRoleHistory}})
                                                                toast.success('User Details Updated', {autoClose: 2000})
                                                                this.toggleTimesheetAlert()
                                                            })
                                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        color="#fff"
                                                        con={loading ? 'spinner' : 'check'}
                                                        spin={loading}
                                                    />{' '}
                                                    {(loading) ? 'Saving...' : "Update Timesheets"}
                                                </Button>
                                            </ModalFooter>
                                        </Modal>
                                    </div>
                                )}
                            </Mutation>
                        )}

                    </Mutation>
                )}
            </Mutation>
        )
    }

}

UserRoleHistory.propTypes = {
    data: PropTypes.array,
    user_id: PropTypes.number.isRequired
}